"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionType = exports.Controllership = exports.TableEncryptionType = exports.UnstructuredSubDataPointRecommendationStatus = exports.SubDataPointDataSubCategoryGuessStatus = exports.ConfidenceLabel = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.ConfidenceLabel = (0, type_utils_1.makeEnum)({
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
});
/** The approval status of the category guess for a subdatapoint */
exports.SubDataPointDataSubCategoryGuessStatus = (0, type_utils_1.makeEnum)({
    /** The guess has been approved as valid */
    Approved: 'APPROVED',
    /** The guess is pending review */
    Pending: 'PENDING',
    /** The guess has been marked as wrong */
    Rejected: 'REJECTED',
});
exports.UnstructuredSubDataPointRecommendationStatus = (0, type_utils_1.makeEnum)({
    /** The category was manually applied */
    ManuallyAdded: 'MANUALLY_ADDED',
    /** The recommendation has been corrected */
    Corrected: 'CORRECTED',
    /** The recommendation has been approved as valid */
    Validated: 'VALIDATED',
    /** The recommendation is has been made but not validated */
    Classified: 'CLASSIFIED',
    /** The recommendation has been marked as wrong */
    Rejected: 'REJECTED',
});
/**
 * Encryption types for database table
 */
exports.TableEncryptionType = (0, type_utils_1.makeEnum)({
    Unencrypted: 'UNENCRYPTED',
    EncryptedApplicationSide: 'ENCRYPTED_APPLICATION_SIDE',
    EncryptedByDataAtRest: 'ENCRYPTED_DATA_AT_REST',
});
exports.Controllership = (0, type_utils_1.makeEnum)({
    /** The current organization is a controller of the data */
    Controller: 'CONTROLLER',
    /** The current organization is a processor of the data */
    Processor: 'PROCESSOR',
    /** The current organization is a joint controller of the data */
    JointController: 'JOINT_CONTROLLER',
});
/** The type of retention schedule for personal data */
exports.RetentionType = (0, type_utils_1.makeEnum)({
    /** Collected user information is deleted, anonymized or aggregated after a specific time period */
    StatedPeriod: 'STATED_PERIOD',
    /** Data is deleted, anonymized, or aggregated at some point, but no specific retention period is stated */
    Limited: 'LIMITED',
    /** Collected user information is retained indefinitely */
    Indefinite: 'INDEFINITE',
    /** A specific retention type not covered above */
    Other: 'OTHER',
    /** Retention period is not stated or unclear */
    Unspecified: 'UNSPECIFIED',
});
//# sourceMappingURL=datapoint.js.map